import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError} from 'rxjs/operators';
import {  Observable, observable, throwError } from 'rxjs';
import { environment } from 'src/app/environments/environments';




const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
  })
};
const httpHeader = {
  headers: new HttpHeaders({
    'Accept' : 'application/json',
    'Content-Type' : 'application/json',
    'Access-Control-Allow-Origin': '*',
    "Access-Control-Allow-Headers":"*"
  })
};
const HeaderConnect={
  headers: new HttpHeaders({

})
}

@Injectable({
  providedIn: 'root'
})
export class RemoteApiService {
  urlRecommender = environment.urlRecommender
  facebookBaseUrl = 'https://graph.facebook.com/' + environment.facebookVersion + '/';
  stripeSubscriptionApiHost = 'https://us-central1-conversell-258914.cloudfunctions.net/stripeSubscription';
  urlMessengerProfile = this.facebookBaseUrl +'me/messenger_profile' 
  urlGetStarted = this.facebookBaseUrl+'me/thread_settings'
  urlCreateLabel =this.facebookBaseUrl+'me/custom_labels?access_token='
  urlPersistentMenu = this.facebookBaseUrl+'me/messenger_profile' 
  urlStartedMessage = this.facebookBaseUrl+'me/messenger_profile'
  urlMessengerProfileForInsta = this.facebookBaseUrl +'me/messenger_profile?platform=instagram' 
  urlPersonas = this.facebookBaseUrl +'me/personas' 
  shortToken = "https://graph.facebook.com/oauth/access_token?client_id="+
  environment.facebookAppKey+"&client_secret="+environment.facebookAppSecretKey+"&grant_type=fb_exchange_token&fb_exchange_token="
  mediaAttachmentUrl="https://graph.facebook.com/v5.0/me/message_attachments?access_token="
  facetsUrl = environment.urlFacets;
  updateFacetUrl = environment.updateFacetUrl;
  updateFacetsRankUrl = environment.updateFacetsRankUrl;
  urlSubscription = 'https://admin.favizone.com/messenger/subscribeConvAppToPage'
  urlUnsubscription = 'https://admin.favizone.com/messenger/unsubscribeAppFromPage'
  urlSetFields = this.facebookBaseUrl+'me/subscribed_apps';
   commonHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': '*',
    }),
  };

  facebookPostAPI(url,reqBody,token) {
    console.log('url,reqBody,token',url,reqBody,token)
    const httRecpOptions = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    let sign  
    sign =  (url.indexOf("?") > -1) ? sign = '&' : '?'  
    return this.http.post(url+sign+'access_token='+token, reqBody, httpOptions)
    .pipe(
      catchError(this.handleError));
  }
  facebookDeleteAPI(reqBody,token) {
    return this.http.delete(this.urlMessengerProfile+'?access_token='+token+`&fields=${reqBody}` )
    .pipe(
  
      catchError(this.handleError));
  }

private httpPost(url: string, body: any, options: any) {
    return this.http.post(url, body, options).pipe(catchError(this.handleError));
}

private httpDelete(url: string, options: any) {
  return this.http.delete(url, options).pipe(catchError(this.handleError));
}

importAdavncedTheme(url: string, body: any) {
  const httRecpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',//added
    })
  };

  return this.http.post(url, body, httRecpOptions)
    .pipe(
      catchError(this.handleError)
    );
}

deleteIntent(urlDelete : string ,dailogFlowToken : string){
    const httRecpOptions = {
      headers: new HttpHeaders({
        'Content-Type':'application/json ; charset=UTF-8',
        'Authorization' :"Bearer " +dailogFlowToken
      })
    };
    return this.http.delete(urlDelete, httRecpOptions)
    .pipe(
      catchError(this.handleError)
    );
  }

   addIntent(url : string,token: string,body: string) {
    const httRecpOptions = {
      headers: new HttpHeaders({
        'Content-Type':'application/json ; charset=UTF-8',
        'Authorization' :"Bearer " +token
      })
    };

    return this.http.post(url, body, httRecpOptions)
    .pipe(
      catchError(this.handleError)
    );
  }
  createKnowldge(url : string,accessToken: string, body: string): any {
    const httRecpOptions = {
      headers: new HttpHeaders({
        'Content-Type':'application/json ; charset=UTF-8',
        'Authorization' :"Bearer "+accessToken
      })
    };
    return this.http.post(url, body, httRecpOptions)
    .pipe(
      catchError(this.handleError)
    );
  }
  addReplayIntent(url: string,token: string,body: string) {
    const httRecpOptions = {
      headers: new HttpHeaders({
        'Content-Type':'application/json ; charset=UTF-8',
        'Authorization' :"Bearer " +token
      })
    };

    return this.http.post(url, body, httRecpOptions)
    .pipe(
      catchError(this.handleError)
    );
  }
  getAgent(urlGet: string,token: string){
    const httRecpOptions = {
      headers: new HttpHeaders({
        'Content-Type':'application/json ; charset=UTF-8',
        'Authorization' :"Bearer " +token
      })
    };
    return this.http.get(urlGet, httRecpOptions)
    .pipe(
      catchError(this.handleError)
    );
  }
createBot(url:string,body: any): Observable<any> {

 return this.httpPost(url, body, this.commonHeaders)


}
  updateIntent(url:string,accessToken:string, body: any): any {
    const httRecpOptions = {
      headers: new HttpHeaders({
        'Content-Type':'application/json ; charset=UTF-8',
        'Authorization' :"Bearer "+accessToken
      })
    };
    return this.http.patch(url, body, httRecpOptions)
    .pipe(
      catchError(this.handleError)
    );
  }
  updateReplayIntent(url : string,accessToken : string, body : any): any {
    console.log('show here' , body)
    const httRecpOptions = {
      headers: new HttpHeaders({
        'Content-Type':'application/json ; charset=UTF-8',
        'Authorization' :"Bearer "+accessToken
      })
    };
    return this.http.patch(url, body, httRecpOptions)
    .pipe(
      catchError(this.handleError)
    );
  }
  qrCodeApi(token : string, data : any) {
    let url = 'https://graph.facebook.com/'+environment.facebookVersion+'/me/messenger_codes?access_token=' + token;

    return this.http.post(url, data, httpHeader)
      .pipe(
        catchError(this.handleError)
      );
  }
  createStripeSubscription(body: any) {
    console.log("fe7rererererer",body);
    const httRecpOptions = {
      headers: new HttpHeaders({
        'Content-Type':'application/json ; charset=UTF-8',
      })
    };
    return this.http.post(this.stripeSubscriptionApiHost+"/create-subscription", body, httRecpOptions)
    .pipe(
      catchError(this.handleError)
    );
  }


  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

  constructor(private http: HttpClient) { }

recommenderApi(shopId : string) {
  const httRecpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'shopId':shopId
    })
  };
  return this.http.get(this.urlRecommender, httRecpOptions)
  .pipe(
    catchError(this.handleError)
  );
}


meneuAPI(reqBody : any ,token : string) {
  return this.http.post(this.urlPersistentMenu+'?access_token='+token, reqBody, httpOptions)
  .pipe(
    catchError(this.handleError));
}

getStartedAPI(reqBody: any ,token: string) {
  return this.http.post(this.urlGetStarted+'?access_token='+token, reqBody, httpOptions)
  .pipe(
    catchError(this.handleError));
}

createLablel(token: string,name: string){
  return this.http.post(this.urlCreateLabel+token+'&name='+name,httpOptions)
  .pipe(
    catchError(this.handleError));
}

pageSubscriptionAPI(token: string,pageId: string) { 
  const reqBody = { "facebookData" : {
    "access_token":token,
    "id":pageId
  },
  "version": environment.facebookVersion,
  "fbAppId":environment.facebookAppKey,
  "fbAppSecretKey":environment.facebookAppSecretKey
  }
return this.http.post(this.urlSubscription,reqBody, httpOptions)
.pipe(
  catchError(this.handleError));
}

pageUnsubscription(token: string,pageId: string) { 
  const reqBody = { "facebookData" : {
    "access_token":token,
    "id":pageId
  },
  "version": environment.facebookVersion,
  }
return this.http.post(this.urlUnsubscription,reqBody, httpOptions)
.pipe(
  catchError(this.handleError));
}

messageApi(message$: string) {
  return this.http.post(this.urlStartedMessage,message$, httpOptions)
  .pipe(
    catchError(this.handleError)
  );
}
setFields(pageId,token){
  return this.http.post(this.facebookBaseUrl+pageId+`/subscribed_apps?subscribed_fields=messages,messaging_postbacks,messaging_optins,
messaging_account_linking,messaging_feedback&access_token=`+token, httpOptions)
  .pipe(
    catchError(this.handleError));
}


UnsubscribeApptoWebhookFacebookPage(pageId,token){
  return this.http.delete(this.facebookBaseUrl+pageId+`/subscribed_apps?access_token=`+token, httpOptions)
  .pipe(
    catchError(this.handleError));
}


CheckConnectToFavizone() {
  let url="https://admin.favizone.com/connect-to-Conversell"
  const res = this.http.get(url, HeaderConnect)
  return res
  .pipe(
  catchError(this.handleError)
  
  );
}
ConnectFavizone(body: any){
let url="https://admin.favizone.com/conversell-login"

return this.http.post(url,body, httpOptions)
.pipe(
  catchError(this.handleError)
);
}
facetsApi(shopId: string)  {
  const facetsHttpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
     // 'authorization': 'Basic RkFWSVpPTkVfUkVNT1RFX1VTRVI6d0NtazRaTidNMkh4KV9SYg=='
    })
  }
  return this.http.get(this.facetsUrl+'/'+shopId, facetsHttpOptions)
  .pipe(
    catchError(this.handleError)
  );
}

updateFacetApi(shopId: string,facet: any)  {
  const facetsHttpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
     // 'authorization': 'Basic RkFWSVpPTkVfUkVNT1RFX1VTRVI6d0NtazRaTidNMkh4KV9SYg=='
    })
  }
  return this.http.post(this.updateFacetUrl+'/'+shopId,facet,facetsHttpOptions)
  .pipe(
    catchError(this.handleError)
  );
}

updateFacetsRankApi(shopId: string,facets: any)  {
  const facetsHttpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
     // 'authorization': 'Basic RkFWSVpPTkVfUkVNT1RFX1VTRVI6d0NtazRaTidNMkh4KV9SYg=='
    })
  }
  return this.http.post(this.updateFacetsRankUrl+'/'+shopId,facets,facetsHttpOptions)
  .pipe(
    catchError(this.handleError)
  );
}
saveFlowData(body: any){
  //
  let url="https://admin.favizone.com/api/update-import-data"
  
  return this.http.post(url,body, httpOptions)
  .pipe(
    catchError(this.handleError)
  );
  }
  favizoneConnection(reqBody: any) {
    return this.http.post(environment.favizoneAccountUrl, reqBody, httpOptions)
    .pipe(
      catchError(this.handleError)
    );
  }
  getAttachmentId(token: string,body: any)  {
 
     console.log('url',this.mediaAttachmentUrl+token)
     console.log(body)
    return this.http.post(this.mediaAttachmentUrl+token,body,httpOptions)
    .pipe(
      catchError(this.handleError)
    );
  }

  simpleGet(url: string) {
    return this.http.get(url).pipe(
      catchError(this.handleError)
    );
  }
  // New Dialogflow
    // Post
    postDialogflow(url: string,accessToken: string, body: any): any {
      const httRecpOptions = {
        headers: new HttpHeaders({
          'Content-Type':'application/json ; charset=UTF-8',
          'Authorization' :"Bearer "+accessToken
        })
      };
      return this.http.post(url, body, httRecpOptions)
      .pipe(
        catchError(this.handleError)
      );
    }
    // Get
    getDialogflow(url: string,accessToken: string): any {
      const httRecpOptions = {
        headers: new HttpHeaders({
          'Content-Type':'application/json ; charset=UTF-8',
          'Authorization' :"Bearer "+accessToken
        })
      };
      return this.http.get(url, httRecpOptions)
      .pipe(
        catchError(this.handleError)
      );
    }
    // Put
    putDialogflow(url: string,accessToken: string, body: any): any {
      const httRecpOptions = {
        headers: new HttpHeaders({
          'Content-Type':'application/json ; charset=UTF-8',
          'Authorization' :"Bearer "+accessToken
        })
      };
      return this.http.put(url, body, httRecpOptions)
      .pipe(
        catchError(this.handleError)
      );
    }
    // delete
    deleteDialogflow(url: string,accessToken: string){
      const httRecpOptions = {
        headers: new HttpHeaders({
          'Content-Type':'application/json ; charset=UTF-8',
          'Authorization' :"Bearer " +accessToken
        })
      };
      return this.http.delete(url, httRecpOptions)
      .pipe(
        catchError(this.handleError)
      );
    }
    
    // New Normal text/json
    getApi(url: string): any {
      console.log('url',url)
      const httRecpOptions = {
        headers: new HttpHeaders({
          'Content-Type':'application/json'
        })
      };
      return this.http.get(url, httRecpOptions)
      .pipe(
        catchError(this.handleError)
      );
    }
    // Post
    postApi(url: string, body: any): any {
      console.log(url,"\n", body)
      const httRecpOptions = httpHeader
      return this.http.post(url, body, httpHeader)
      .pipe(
        catchError(this.handleError)
      );
    }

    
    postApiWithParams(url: string,  queryParameters: any ,body: any ): any {
      console.log( 'TEST',  url,"\n", body)
      let params = new HttpParams();
    for (const key in queryParameters) {
      if (queryParameters.hasOwnProperty(key)) {
        params = params.append(key, queryParameters[key]);
      }
    }
    console.log('params',params)
      //const httRecpOptions = httpHeader
      return this.http.post(url, body, { params })
      .pipe(
        catchError(this.handleError)
      );
    }
    postApiWithBody(url: string,  body: any ): any {
      console.log( 'TEST WithBody',  url,"\n", body)
      
      return this.http.post(url, body)
      .pipe(
        catchError(this.handleError)
      );
    }
    postApiWithQueryParams(url: string,  queryParameters: any ): any {
      console.log( 'TEST',  url)
      let params = new HttpParams();
    for (const key in queryParameters) {
      if (queryParameters.hasOwnProperty(key)) {
        params = params.append(key, queryParameters[key]);
      }
    }
      const httRecpOptions = httpHeader
      return this.http.post(url, { params })
      .pipe(
        catchError(this.handleError)
      );
    }
    // PUT with QueryParams
    putApiWithQueryParams(url: string, params: any): Observable<any> {
      console.log( 'TEST',  url)
      let queryParams = new HttpParams();
      // Construction des paramètres de requête à partir de l'objet params
      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          queryParams = queryParams.append(key, params[key]);
        }
      }
  
      return this.http.put(url, null, { params: queryParams });
    }
   /* putApiWithQueryParams(url: string,  queryParameters: any ): any {
      console.log( 'TEST',  url)
      let params = new HttpParams();
      for (const key in queryParameters) {
        if (queryParameters.hasOwnProperty(key)) {
          params = params.append(key, queryParameters[key]);
        }
      }
      const httRecpOptions = {
        headers: new HttpHeaders({
          'Content-Type':'application/json',
        })
      };
      console.log('params',params)
      console.log('url',url)
      return this.http.put(url, { params })
      .pipe(
        catchError(this.handleError)
      );
    }*/
  
    deleteApiWithParams(url: string, queryParameters: any){
      let params = new HttpParams();
      for (const key in queryParameters) {
        if (queryParameters.hasOwnProperty(key)) {
          params = params.append(key, queryParameters[key]);
        }
      }
      const httRecpOptions = {
        headers: new HttpHeaders({
          'Content-Type':'application/json',
        })
      };
      console.log('params',params)
      console.log('url',url)
      return this.http.delete(url, {params})
      .pipe(
        catchError(this.handleError)
      );
    }
    updateFiles(putUrl: string, queryParams: any, formData: FormData): Observable<any> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
  
      let params = new HttpParams();
      for (const key in queryParams) {
        if (queryParams.hasOwnProperty(key)) {
          params = params.set(key, queryParams[key]);
        }
      }
  
      return this.http.put(putUrl, formData, { headers: headers, params: params });
    }
    // delete
    deleteApi(url: string){
      const httRecpOptions = {
        headers: new HttpHeaders({
          'Content-Type':'application/json',
        })
      };
      return this.http.delete(url, httRecpOptions)
      .pipe(
        catchError(this.handleError)
      );
    }
    getfileContent(url: string): any {
      return this.http.get(url, {responseType: "text"}).pipe(
        catchError(this.handleError)
      );
    }
    getStripePaymentPortailSession(body: any) {
      console.log("fe7rererererer",body);
      const httRecpOptions = {
        headers: new HttpHeaders({
          'Content-Type':'application/json ; charset=UTF-8',
        })
      };
      return this.http.post(this.stripeSubscriptionApiHost+"/create-customer-portal-session", body, httRecpOptions)
      .pipe(
        catchError(this.handleError)
      );
    }
    getPageAccessToken(pageId,accessToken): any {
      const httRecpOptions = {
        headers: new HttpHeaders({
          'Content-Type':'application/json'
        })
      };
      return this.http.get(this.facebookBaseUrl+pageId+'?fields=access_token&access_token='+accessToken, httRecpOptions)
      .pipe(
        catchError(this.handleError)
      );
    }
   
}
